import getEducationLevel from '@/utils/EducationLevelUtils';
import { ProgrammeSearchInput } from '@studyportals/search-api-interface';
import { AttendanceFilterOptionValue, EducationLevelFilterOptionValue } from '@studyportals/search-filters/server-side';

const getPortalFacetFilter = (): ProgrammeSearchInput => {
	const educationalLevels = getEducationLevel();
	const isDistanceLearning = educationalLevels?.[0] === EducationLevelFilterOptionValue.DISTANCE_LEARNING;

	const portalFilter: ProgrammeSearchInput = isDistanceLearning
		? { attendances: [AttendanceFilterOptionValue.ONLINE, AttendanceFilterOptionValue.BLENDED] }
		: { educationalLevels };

	return portalFilter;
}

export default getPortalFacetFilter;